import { Box } from '@mui/material'

import LogoColor from '../../../images/cityeyedataviz.svg'
import LogoWhite from '../../../images/cityeyedatawhite.svg'
import { useGlobalContext } from '../../Shared/Contexts/GlobalContext'

const Logo = () => {
  const { theme } = useGlobalContext()

  return (
    <>
      {theme === 'light' && (
        <Box
          component="img"
          sx={{
            maxWidth: '100%',
            maxHeight: '70px'
          }}
          src={LogoColor}
          alt='CityEye dataviz logo'
        />
      )}
      {theme === 'dark' && (
        <Box
          component="img"
          sx={{
            maxWidth: '100%',
            maxHeight: '70px'
          }}
          src={LogoWhite}
          alt='CityEye dataviz logo'
        />
      )}
    </>
  )
}

export default Logo
